import { render, staticRenderFns } from "./CompanyMgmt.vue?vue&type=template&id=6382852b&"
import script from "./CompanyMgmt.vue?vue&type=script&lang=ts&"
export * from "./CompanyMgmt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports